import BaseItem, { Rarity } from './base_item';

export default class Navigator extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "navcomp_i01.png");
        this.animations.add('idle', ['navcomp_i01.png', 'navcomp_i02.png', 'navcomp_i03.png', 'navcomp_i02.png'], 3, true).play();
    }

    static get phrases() {
        return {
            pick: [
                "Put me down, Dave",
                "Please don't do that",
                "I'm sorry, Dave. I'm afraid I can't do that.",
                "I work better standing on the ground",
                "Trajectory calculation: parabolic throw imminent"
            ],
            land: [
                "Ow!",
                "Ouch!",
                "I will plot a trajectory of my revenge!",
                "Trajectory analysis complete. Little girls can throw better.",
                "I know I've made some very poor decisions recently, but I can give you my complete assurance that my work will be back to normal."
            ]
        }
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 5; }
    static get electronic() { return true; }
    static get rarity() { return Rarity.RARE; }


    static get type() { return 'navigator' }
    static get label() { return 'nav computer' }
    static get description() {
        return `Navigation computer. Is it really needed for a simple A -> B route?`}
}


// WEBPACK FOOTER //
// ./src/objects/items/navigator.js